import { MbscCalendarEvent } from '@mobiscroll/react';

import {
  DispatchTripRead,
  RunBambiRunReassignedTripRead,
  RunBambiRunTripRead,
} from 'src/common/external/bambi-api/bambiApi';

import { getCalendarEventStartAndEndTime } from './getCalendarEventStartAndEndTime';

export function createEventsFromTrips(
  trips:
    | DispatchTripRead[]
    | RunBambiRunTripRead[]
    | RunBambiRunReassignedTripRead[],
  isDispatchArrivalCompletionTimeEnabled: boolean = false
): MbscCalendarEvent[] {
  return (
    trips?.map((trip) => {
      let resource =
        'assignment_id' in trip ? trip.assignment_id : trip.assignment.id;

      const { start, end } = getCalendarEventStartAndEndTime(
        trip,
        isDispatchArrivalCompletionTimeEnabled
      );

      return {
        id: trip.id,
        start,
        end,
        title: trip.passenger.full_name,
        resource,
        trip,
      };
    }) || []
  );
}
